<template>
  <div class="mt-6" style="width:100%;" id="group-locations">
    <locations
      :_deviceLocations="groupLocations"
      :centerLocation="{ lat: details.lat, lng: details.lng }"
      :isScreen="true"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Locations from '@/components/app/Locations';
import GroupDetailData from '@/mixins/GroupDetailData';
import { MobileView } from '@/mixins';

export default {
  components: {
    Locations,
  },
  mixins: [MobileView, GroupDetailData],
  computed: {
    ...mapGetters({
      groupLocations: 'groupDetails/getGroupLocations',
    }),
    headerStyle() {
      if (this.showMobileView) {
        return '';
      }
      return 'position: absolute; bottom: 450px; z-index: 5; width: 350px;';
    },
    centerLocation() {
      if (this.details.lat && this.details.lng) {
        return { lat: this.details.lat, lng: this.details.lng };
      }
      return { lat: this.groupLocations[0].lat, lng: this.groupLocations[0].lng };
    },
  },
};
</script>
